import View from '../View';
import {percent, px} from '@packages/systems/core/utils/WebflowCssSubset';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Div Block',
  showEmpty: true,
  constraints: {
    ancestors: [{is: 'CommerceCartItem', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          marginRight: px(16),
          marginLeft: px(16),
          flexDirection: 'column',
          flexGrow: 1,
          flexShrink: 1,
          flexBasis: percent(0),
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
